export default __webpack_public_path__ + "static/media/gif.d0760456.svg";